import { gql } from "@apollo/client";

export const LISTING_PARTS_FRAGMENT = gql`
  fragment ListingParts on Listing {
    id
    listed_price
    closed_at
    baths_description
    bedrooms_description
    title_with_unit
    anyrooms_description
    size_sqft
    contacts {
      id
      name
      profile {
        id
        url
      }
    }
    address {
      unit
      pretty_address
    }
    url
    status_title
    status
  }
`;
export const BUILDING_PARTS_FRAGMENT = gql`
  fragment BuildingParts on Building {
    id
    address {
      pretty_address
    }
  }
`;
export const EXPERT_FRAGMENT = gql`
  fragment ExpertData on ExpertInterface {
    id
    recent_deals_count
    sales_in_area_count
    rentals_in_area_count
    contact {
      id
      business_name
      business_url
      email
      is_pro
      name
      profile {
        id
        url
        name
      }
      image {
        id
        url(width: 100, height: 100, quality: 100)
      }
      industry_professional {
        id
        headshot {
          id
          url(width: 100, height: 100, quality: 100)
        }
      }
      license {
        id
        display_type
      }
    }
  }
`;
export const LISTING_DEALS_PAGE_FRAGMENT = gql`
  fragment ListingDealsPage on ListingDealsPage {
    total_count
    page_info {
      current_page
      total_pages
    }
  }
`;
const AGENT_LISTING_PARTS_FRAGMENT = gql`
  fragment AgentListingParts on AgentListing {
    id
    address
    bathrooms
    bedrooms
    closed_at
    listing_status
    listing_type
    listing_url
    price
    size_sqft
    unit
  }
`;
export const LISTING_DEALS_PAGE_WITH_ITEMS_FRAGMENT = gql`
  fragment ListingDealsPageWithItems on ListingDealsPage {
    ...ListingDealsPage
    items {
      ...AgentListingParts
    }
  }
  ${LISTING_DEALS_PAGE_FRAGMENT}
  ${AGENT_LISTING_PARTS_FRAGMENT}
`;
